import drsUrl from '@drs/url';
import evercallUrl from '@evercall/url';
import { dataroomUrl } from '@dataroom/url';
import CFR_URL from '@/creditflowresearch/Router/urlConstants';
import staticUrls from '@finsight/urls/static';
import finsightConfig from '@finsight/config';
import dataroomConfig from '@dataroom/config';
import { IFooter } from '@/finsight/domain/vo/IFooter';
import cfrUrl from '@/creditflowresearch/infrastructure/url';

import styles from '@/finsight/ui/common/components/Footer/footer.module.scss';

const classNames = {
  columnTitleClassName: styles.columnTitle,
  panelClassName: styles.panel,
  arrowClassName: styles.panelArrow,
  columnClassName: styles.column,
};

export const footerCollection: IFooter = {
  navigation: [
    {
      path: staticUrls.getComplianceUrl(),
      title: 'Compliance',
      shouldOpenInNewTab: true,
    },
    {
      path: staticUrls.getPrivacyPolicyUrl(),
      title: 'Privacy',
      shouldOpenInNewTab: true,
    },
    {
      path: staticUrls.getSecurityPolicyUrl(),
      title: 'Security',
      shouldOpenInNewTab: true,
    },
    {
      path: staticUrls.getTermsOfUseUrl(),
      title: 'Terms',
      shouldOpenInNewTab: true,
    },
  ],
  content: [
    {
      key: 'company',
      title: 'Company',
      ...classNames,
      collection: [
        { title: 'About', path: staticUrls.getAboutUrl() },
        { title: 'Careers', path: staticUrls.getCareersUrl() },
        { title: 'Contact', path: staticUrls.getContactUrl() },
        { title: 'Solutions', path: staticUrls.getSolutionsUrl() },
      ],
    },
    {
      key: 'finsight',
      title: 'CreditFlow',
      ...classNames,
      collection: [
        { title: 'Global Issuers List', path: CFR_URL.ISSUERS_LIST },
        { title: 'Global Parents List', path: CFR_URL.SPONSORS_LIST },
        { title: 'Pricing', path: CFR_URL.PRICING },
        { title: 'OpenMarket Profiles', path: CFR_URL.OPEN_MARKET },
      ],
    },
    {
      key: 'products',
      title: 'Products',
      ...classNames,
      collection: [
        {
          title: 'CapEdge',
          // @todo: move this to config and create separate tenant in docker and MG
          path: 'https://capedge.com',
          shouldOpenInNewTab: true,
        },
        {
          title: 'Deal Roadshow',
          path: drsUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'DealVDR',
          path: dataroomUrl(dataroomConfig.dealvdr.code).getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'Evercall',
          path: evercallUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'CreditFlow',
          path: cfrUrl.getUrl(),
          shouldOpenInNewTab: true,
        },
        {
          title: 'More',
          path: staticUrls.getSolutionsUrl(),
          shouldOpenInNewTab: true,
        },
      ],
    },
    {
      key: 'sales',
      title: 'Sales & Support',
      ...classNames,
      collection: [
        { title: 'Americas', phoneNumber: '+1 888 997 6610 ' },
        { title: 'APAC', phoneNumber: '+852 3018 1600' },
        { title: 'EMEA', phoneNumber: '+44 80817 87364' },
        {
          title: `${ finsightConfig.supportEmail }`,
          path: `mailto:${ finsightConfig.supportEmail }?subject=Finsight Sales %26 Support Request`,
          linkClassName: styles.supportEmailLink,
        },
      ],
    },
  ],
};
